import React, { useEffect } from "react";
import CustomHtmlEmbed from "./CustomHtmlEmbed";
import CustomAppEmbed from "./CustomAppEmbed";
import LinkEmbed from "./LinkEmbed";
import FormEmbed from "./FormEmbed";
import RichTextEmbed from "./RichTextEmbed";
import DocumentEmbeded from "./Document/DocumentEmbeded";
import TravelEmbed from "./TravelEmbed";

export default function BasicRouter({ content, config, setError }) {
  useEffect(() => {
    if (!config?.provider) {
      setError("Provider type does not exist.");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config?.provider]);

  return (
    <>
      {config?.type === "CUSTOM_HTML" && <CustomHtmlEmbed content={content} />}
      {config?.type === "CUSTOM_APP" && <CustomAppEmbed content={content} />}
      {config?.type === "EXTERNAL_LINK" && <LinkEmbed content={content} />}
      {config?.type === "FORM" && <FormEmbed content={content} />}
      {config?.type === "RICH_TEXT" && <RichTextEmbed content={content} />}
      {config?.type === "DOCUMENT" && (
        <DocumentEmbeded
          name={content?.page_name}
          content={content}
          documents={Array.from(new Map([...(Array.isArray(content?.documents) ? content.documents : []), ...(Array.isArray(content?.groupDocuments) ? content.groupDocuments : [])].map((doc) => [doc._id, doc])).values())}
        />
      )}
      {config?.type === "TRAVEL" && <TravelEmbed content={content} />}
    </>
  );
}
